export const TRANSACTION_DATE_COLUMN_KEY = 'transactionDate'
export const TRANSACTION_DATE_COLUMN_WIDTH = 170

// Column width constants for settlements table
export const SETTLEMENT_DATE_COLUMN_WIDTH = 160
export const ADDRESS_COLUMN_WIDTH = 180
export const POSTCODE_COLUMN_WIDTH = 150
export const MID_COLUMN_WIDTH = 150
export const TERMINAL_NUMBER_COLUMN_WIDTH = 150
export const AMOUNT_COLUMN_WIDTH = 200
export const SETTLEMENT_TYPE_COLUMN_WIDTH = 200
export const TOTAL_FEE_COLUMN_WIDTH = 150
export const INTERCHANGE_FEE_COLUMN_WIDTH = 150
export const SCHEME_FEE_COLUMN_WIDTH = 120
export const PROCESSING_FEE_COLUMN_WIDTH = 120
export const GATEWAY_FEE_COLUMN_WIDTH = 120
export const AUTHORISATION_FEE_COLUMN_WIDTH = 135
export const BLENDED_FEE_COLUMN_WIDTH = 120
export const REFUND_FEE_COLUMN_WIDTH = 120
export const AMOUNT_TO_SETTLE_COLUMN_WIDTH = 160
export const SORT_CODE_COLUMN_WIDTH = 100
export const ACCOUNT_NUMBER_COLUMN_WIDTH = 160
export const OPERATION_COLUMN_WIDTH = 110
export const TRANSACTION_TYPE_COLUMN_WIDTH = 160
export const TRANSACTION_ID_COLUMN_WIDTH = 190
export const PAYOUT_REFERENCE_COLUMN_WIDTH = 220
export const MERCHANT_REFERENCE_COLUMN_WIDTH = 180
export const PAYMENT_METHOD_COLUMN_WIDTH = 160
export const PRODUCT_GROUP_COLUMN_WIDTH = 140
export const CARDHOLDER_NAME_COLUMN_WIDTH = 150
export const CARD_TYPE_COLUMN_WIDTH = 120
export const ISSUER_REGION_COLUMN_WIDTH = 150
export const ISSUER_COUNTRY_COLUMN_WIDTH = 140
export const IS_CORPORATE_CARD_COLUMN_WIDTH = 170
export const CAPTURE_METHOD_COLUMN_WIDTH = 150
export const VAT_COLUMN_WIDTH = 150
